var JabberSendChatStateData = /** @class */ (function () {
    function JabberSendChatStateData(to, from, type, chatState) {
        this.to = to;
        this.from = from;
        this.type = type;
        this.chatState = chatState;
    }
    return JabberSendChatStateData;
}());
export { JabberSendChatStateData };
//# sourceMappingURL=jabber-send-chat-state-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/jabber-dto/jabber-send-chat-state-data.js
// module id = 902
// module chunks = 14